import { dataMember, required, typedArray } from 'santee-dcts';
import * as moment from 'moment';
import { deserializers } from '../../../core';
import { siteDisplayNameRenderer } from '../../../renderer/site-display-name-renderer';

export class AdminAccessinvestigationReport {
    @dataMember()
    @required({ nullable: true })
    public sponsorName: string;

    @dataMember()
    @required({ nullable: true })
    public protocolName: string;

    @dataMember()
    @required({ nullable: true })
    public zcProjectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public siteName: string;

    @dataMember()
    @required({ nullable: true })
    public siteNum: string;

    @dataMember()
    @required()
    public userName: string;

    @dataMember()
    @required()
    public email: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required()
    public startDateTime: moment.Moment;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public endDateTime: moment.Moment;

    @dataMember()
    @required()
    public action: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate})
    @required()
    public actionDateTime: moment.Moment;

    @dataMember()
    @required()
    public module: string;

    public get siteDisplayName(): string {
        return siteDisplayNameRenderer({siteNumber: this.siteNum, investigatorFullName: this.siteName});
    }
}

export class AdminAccessinvestigationReportReadModel {
    @dataMember()
    @required()
    @typedArray(AdminAccessinvestigationReport)
    public reports: AdminAccessinvestigationReport[];
}
